import { Button, Stack } from '@chakra-ui/react';
import QuestionComponent from '~/components/Forms/QuestionComponent';
import { serializeQuestions, sortQuestionsByOrder } from '~/components/Forms/utils';
import { navigate, useStaticQuery } from 'gatsby';
import React from 'react';
import { useForm } from 'react-hook-form';

var HeroSearchForm = function HeroSearchForm(props) {
  var _data$wpSiteSetting, _data$wpSiteSetting$a, _data$wpSiteSetting3, _data$wpSiteSetting3$, _data$wpSiteSetting3$2, _data$wpSiteSetting4, _data$wpSiteSetting4$, _data$wpSiteSetting4$2;

  var _useForm = useForm(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      watch = _useForm.watch;

  var data = useStaticQuery(query);
  var questions = (_data$wpSiteSetting = data.wpSiteSetting) === null || _data$wpSiteSetting === void 0 ? void 0 : (_data$wpSiteSetting$a = _data$wpSiteSetting.acfHeroSearchForm) === null || _data$wpSiteSetting$a === void 0 ? void 0 : _data$wpSiteSetting$a.questions;
  if (!questions) return null;
  var questionKeys = Object.keys(questions);
  var questionsWithFullDropdownOptions = questionKeys.reduce(function (acc, currentQuestionKey) {
    var _props$displayedField, _Object$assign; // @ts-ignore


    var questionData = questions[currentQuestionKey];
    if (!((_props$displayedField = props.displayedFields) !== null && _props$displayedField !== void 0 && _props$displayedField.includes(questionData.name))) return acc;
    var options;

    switch (questionData.name) {
      case 'destination':
        var destinations = data.allWpDestination.nodes;
        options = destinations.map(function (destinationItem) {
          var _destinationItem$acfD, _destinationItem$acfD2;

          return {
            defaultValue: null,
            label: (_destinationItem$acfD = destinationItem.acfDestination) === null || _destinationItem$acfD === void 0 ? void 0 : (_destinationItem$acfD2 = _destinationItem$acfD.heroDestination) === null || _destinationItem$acfD2 === void 0 ? void 0 : _destinationItem$acfD2.destinationName,
            name: destinationItem.slug
          };
        });
        break;

      case 'formule':
        var formules = data.allWpFormule.nodes;
        options = formules.map(function (formule) {
          var _formule$acfFormule, _formule$acfFormule$i;

          return {
            defaultValue: null,
            label: (_formule$acfFormule = formule.acfFormule) === null || _formule$acfFormule === void 0 ? void 0 : (_formule$acfFormule$i = _formule$acfFormule.informations) === null || _formule$acfFormule$i === void 0 ? void 0 : _formule$acfFormule$i.title,
            name: formule.slug
          };
        });
        break;

      case 'language':
        var languages = data.allWpLangue.nodes;
        options = languages.map(function (language) {
          var _language$acfLanguage, _language$acfLanguage2;

          return {
            defaultValue: null,
            label: (_language$acfLanguage = language.acfLanguage) === null || _language$acfLanguage === void 0 ? void 0 : (_language$acfLanguage2 = _language$acfLanguage.informations) === null || _language$acfLanguage2 === void 0 ? void 0 : _language$acfLanguage2.languageNameShort,
            name: language.slug
          };
        });
        break;

      case 'city':
        var cities = data.allWpVille.nodes;
        var destination = props.destination || watch('destination');
        var citiesToDisplay = destination ? cities.filter(function (city) {
          var _city$acfVille, _city$acfVille$countr, _city$acfVille$countr2;

          return (city === null || city === void 0 ? void 0 : (_city$acfVille = city.acfVille) === null || _city$acfVille === void 0 ? void 0 : (_city$acfVille$countr = _city$acfVille.country) === null || _city$acfVille$countr === void 0 ? void 0 : (_city$acfVille$countr2 = _city$acfVille$countr[0]) === null || _city$acfVille$countr2 === void 0 ? void 0 : _city$acfVille$countr2.slug) === destination;
        }) : cities;
        options = citiesToDisplay.map(function (city) {
          return {
            defaultValue: null,
            label: city.title,
            name: city.slug
          };
        });
        break;

      default:
        break;
    }

    return Object.assign({}, acc, (_Object$assign = {}, _Object$assign[currentQuestionKey] = Object.assign({}, questionData, {
      options: options
    }), _Object$assign));
  }, {});
  var sortedQuestions = sortQuestionsByOrder(questionsWithFullDropdownOptions);
  var serializedQuestions = serializeQuestions(sortedQuestions);

  var onSubmit = function onSubmit(formData) {
    var _data$wpSiteSetting2, _data$wpSiteSetting2$, _data$wpSiteSetting2$2, _data$wpSiteSetting2$3;

    var link = (_data$wpSiteSetting2 = data.wpSiteSetting) === null || _data$wpSiteSetting2 === void 0 ? void 0 : (_data$wpSiteSetting2$ = _data$wpSiteSetting2.acfHeroSearchForm) === null || _data$wpSiteSetting2$ === void 0 ? void 0 : (_data$wpSiteSetting2$2 = _data$wpSiteSetting2$.cta) === null || _data$wpSiteSetting2$2 === void 0 ? void 0 : (_data$wpSiteSetting2$3 = _data$wpSiteSetting2$2.internalLink) === null || _data$wpSiteSetting2$3 === void 0 ? void 0 : _data$wpSiteSetting2$3[0];
    if (link) navigate(link.uri, {
      state: Object.assign({
        city: props.city,
        destination: props.destination,
        duration: props.duration,
        formule: props.formule,
        language: props.language
      }, formData)
    });
  };

  return /*#__PURE__*/React.createElement(Stack, {
    as: "form",
    onSubmit: handleSubmit(onSubmit),
    justify: "center",
    align: "flex-end",
    w: "100%",
    maxW: "400px"
  }, serializedQuestions.map(function (question) {
    return /*#__PURE__*/React.createElement(QuestionComponent, {
      key: question.name,
      register: register,
      questionData: question,
      color: "white"
    });
  }), /*#__PURE__*/React.createElement(Button, {
    variant: (_data$wpSiteSetting3 = data.wpSiteSetting) === null || _data$wpSiteSetting3 === void 0 ? void 0 : (_data$wpSiteSetting3$ = _data$wpSiteSetting3.acfHeroSearchForm) === null || _data$wpSiteSetting3$ === void 0 ? void 0 : (_data$wpSiteSetting3$2 = _data$wpSiteSetting3$.cta) === null || _data$wpSiteSetting3$2 === void 0 ? void 0 : _data$wpSiteSetting3$2.variant,
    alignSelf: {
      base: 'flex-start',
      lg: 'flex-end'
    },
    type: "submit"
  }, (_data$wpSiteSetting4 = data.wpSiteSetting) === null || _data$wpSiteSetting4 === void 0 ? void 0 : (_data$wpSiteSetting4$ = _data$wpSiteSetting4.acfHeroSearchForm) === null || _data$wpSiteSetting4$ === void 0 ? void 0 : (_data$wpSiteSetting4$2 = _data$wpSiteSetting4$.cta) === null || _data$wpSiteSetting4$2 === void 0 ? void 0 : _data$wpSiteSetting4$2.label));
};

export default HeroSearchForm;
var query = "3682371732";